var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.data,"item-key":"_id","footer-props":{
      'items-per-page-options': [10, 20, 50, 100, 200, 500]
    },"items-per-page":100}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }